import { Button } from "primereact/button";

import { Dropdown, Icon } from "@/ds";
import { QuickMultiSelectFilter } from "@/shared/components/quick-multi-select-filter";
import {
  FILTRO_MAX_ITENS,
  FILTRO_SEM_RESULTADO_MESSAGE,
  LIMPAR_FILTROS_LABEL,
} from "./filtros-inline.constants";
import styles from "./filtros-inline.module.scss";
import type { FiltroInlineCampo, FiltrosInlineViewModel } from "./types-filtros-inline";

/** Escolha única preenchida (Figma 5264:65711 e 5264:65992): o ícone, o rótulo em Medium, dois-pontos e o valor. */
function renderRotuloValor({ placeholder, rotuloSelecionado, icone }: FiltroInlineCampo) {
  return (
    <span className={styles.rotuloValor}>
      {icone ? <Icon name={icone} size={14} className={styles.icone} /> : null}
      <span className={styles.rotulo}>{placeholder}:</span> {rotuloSelecionado}
    </span>
  );
}

export function FiltrosInlineView({
  campos,
  mostrarLimpar,
  limpar,
  limparTestId,
}: FiltrosInlineViewModel) {
  return (
    <div className={styles.filtros}>
      {campos.map((campo) =>
        campo.multiplo ? (
          <QuickMultiSelectFilter
            key={campo.key}
            className={campo.className}
            value={campo.valores}
            options={campo.options}
            placeholder={campo.placeholder}
            aria-label={campo.placeholder}
            filter={campo.buscavel}
            filterPlaceholder={campo.searchPlaceholder}
            emptyMessage={campo.mensagemVazia}
            emptyFilterMessage={FILTRO_SEM_RESULTADO_MESSAGE}
            selectionLimit={FILTRO_MAX_ITENS}
            onChange={campo.escolherVarios}
            onClear={campo.limpar}
            data-testid={campo.testId}
          />
        ) : (
          <Dropdown
            key={campo.key}
            className={campo.className}
            pt={{ input: { className: styles.rotuloDropdown } }}
            value={campo.valorUnico}
            options={campo.options}
            optionLabel="label"
            optionValue="value"
            placeholder={campo.placeholder}
            ariaLabel={campo.placeholder}
            showClear={false}
            filter={campo.buscavel}
            filterPlaceholder={campo.searchPlaceholder}
            emptyMessage={campo.mensagemVazia}
            emptyFilterMessage={FILTRO_SEM_RESULTADO_MESSAGE}
            valueTemplate={campo.rotuloSelecionado ? () => renderRotuloValor(campo) : undefined}
            onChange={(event) => campo.escolher(event.value ?? null)}
            data-testid={campo.testId}
          />
        ),
      )}

      {mostrarLimpar ? (
        <Button
          type="button"
          className={styles.limpar}
          label={LIMPAR_FILTROS_LABEL}
          severity="secondary"
          onClick={limpar}
          data-testid={limparTestId}
        />
      ) : null}
    </div>
  );
}
